// extracted by mini-css-extract-plugin
module.exports = {"list":"ServiceSubscriptionList_list__11SB1"};